import { useQuery } from 'react-query'
import ApiClient from '../lib/api-client'

export const dataSourceKeys = {
  all: ['data-sources'],
  lists: () => [...dataSourceKeys.all, 'list'],
  list: (filter, sort) => [...dataSourceKeys.lists(), { filter, sort }],
  details: () => [...dataSourceKeys.all, 'detail'],
  detail: (id) => [...dataSourceKeys.details(), id]
}

async function fetchDataSources (filter, sort) {
  const baseUrl = '/community/data-sources'
  const searchParams = new URLSearchParams()

  if (filter) {
    Object.keys(filter).forEach(key => {
      const value = filter[key]
      if (Array.isArray(value)) {
        searchParams.append(key, value.join(','))
      } else {
        searchParams.append(key, value)
      }
    })
  }

  if (sort) {
    searchParams.append('sort', sort)
  }
  const url = `${baseUrl}?${searchParams.toString()}`
  return ApiClient.get(url).then(data => data)
}

function useDataSources (filter, sort, select) {
  return useQuery(
    dataSourceKeys.list(filter, sort),
    () => fetchDataSources(filter, sort),
    {
      select,
      refetchOnWindowFocus: true
    }
  )
}

export function useDataSourceOptions (filter) {
  return useDataSources(filter, '+name', (data) => data
    .dataSources
    .map(x => ({ value: x.id, label: x.name })))
}

export function useDataSourceCount () {
  return useDataSources(null, '-updatedAt', (data) => data
    .dataSources
    .length)
}

export function useDataSourceHasFailed () {
  return useDataSources(null, '+name', (data) => {
    return data.dataSources.some(x => x.connectivity === 0)
  })
}

export default useDataSources
